/* istanbul ignore file */
import { Dayjs } from 'dayjs';
import { MSALHolder } from '@/lib/msal';
import {
    AiiaExchangeCodeRequest,
    ApproveTransactionsRequest,
    CreateCompanyAccountTransactionRequest,
    DeleteCompanyRequest,
    FailTransactionsRequest,
    GetAiiaAuthorizeUrlRequest,
    GetAiiaRetryAuthorizeUrlRequest,
    GetIntectUsersDetailedReqest,
    GetZenegyUsersDetailedReqest,
    IntectAuthorizeRequest,
    PlandaySetupRequest,
    RejectTransactionsRequest,
    SendDeleteCompanyVerificationEmailRequest,
    SucceedTransactionsRequest,
    UpdateCompanyDanskeBankSettingsRequest,
    UpdateCompanyPaymentsRequest,
    UpdateDepartmentsRequest,
    UpdateEmployeeTypesRequest,
    UpdateIntectDepartmentsRequest,
    UpdateIntectEmploymentTemplateRequest,
    UpdateSalaryModesRequest,
    UpdateSalaryProviderRequest,
    UpdateSalaryTypesRequest,
    UpdateTimeRegistrationProviderRequest,
    UpdateUserBankAccountDetailsRequest,
    ZenegyExchangeCodeRequest,
    CompanyDetailsResponse,
    GetUsersDetailedRequest,
    TamigoSetupRequest,
    DataLonSetupRequest,
    SameSystemRequest,
    ProloenSetupRequest,
    TrivecSetupRequest,
    UserDetailedResponse,
    ZenegyUserDetailed,
    CompanyBalanceResponse,
    TransactionExecutionType,
    PaymentProvider,
    ShiftTypes,
    TitanPlanRequest,
    EPOSSetupRequest,
    StaffSetupRequest,
    LessorSetupRequest,
    QuinyxSetupRequest,
    DagrofaLonSetupRequest
} from '@/models/payment';
import BaseAPI from './baseServiceV2';
import axios, { AxiosInstance } from 'axios';
import { TransactionsDetailedResponse } from '@/models/transaction';
import {
    EmployeeDetailRequest,
    EmployeeDetailResponse
} from './ReportsInternalTypes';
import {
    ApprovalType,
    ChangeUsersStatusRequest,
    LowBalanceAudience,
    PaymentSource
} from '@/models/company';
import { ShiftStatusWithdrawAllowed } from '@instapaid/shared-logic';

import { Transaction as TransactionCommon } from '@/models/transaction';

export interface UpcomingShiftsRepsonse {
    currentPeriodShifts: CurrentPeriodShifts;
}

export interface CurrentPeriodShifts {
    start: string;
    end: string;
    totalHours: number;
    totalAmount: number;
    shifts: Shift[];
}

export interface AvailableShifts {
    start: string;
    end: string;
    totalHours: number;
    totalAmount: number;
    shifts: AvailableShift[];
}

export interface AvailableShift extends Shift {
    hourlyRateFrom: string;
    amountV2: number;
    hourlyRate: number;
    groupName: string;
}

export interface Shift {
    id: string;
    status: string;
    startTime: Dayjs | null;
    endTime: Dayjs | null;
    break: number;
    duration: number;
    amount: number;
    availableForPayout: boolean;
    isShiftTypeExcluded: boolean;
}

export interface TransactionsResponse {
    transactions: Transaction[];
    total: number;
    filteredTotal: number;
}

export interface Transaction extends TransactionCommon {}

export interface EmployeeTypeSettingsResponse {
    employeeTypes: EmployeeTypeSettings[];
}

export enum AutoControlAction {
    AutoDisableUsers = 'AutoDisableUsers',
    AutoEnableUsers = 'AutoEnableUsers',
    Ignore = 'DoNothing'
}

export interface EmployeeTypeSettings {
    employeeTypeId: number;
    name: string;
    description: string;
    autoEnableUsers: boolean;
    employmentType: string;
    usersAutoControlAction: AutoControlAction;
}

export interface CompanyDisableVerificationEmailRequest {
    companyId: string;
}

export interface CompanyStatusRequest {
    companyId: string;
    isDisabled: boolean;
    verificationCode: string;
}

export interface TimeRegistrationProviders {
    providers: Provider[];
}

export interface Provider {
    id: number;
    name: string;
    isSalaryProvider: boolean;
    isTimeRegistrationProvider: boolean;
    isPaymentProvider: boolean;
    fileUrl: string;
}

export interface DepartmentV2Response {
    departments: DepartmentV2[];
}

export interface DepartmentV2 {
    departmentId: string;
    departmentName: string;
}

export interface EmployeeTypeV2Response {
    employeeTypes: EmployeeTypeV2[];
}

export interface EmployeeTypeV2 {
    employeeTypeId: string;
    employeeTypeName: string;
}

export interface UserResponse {
    userId: string;
    email: string;
    bankCode: string;
    bankAccountNumber: string;
    cprNumber: string;
    isGobalAdmin: boolean;
    isNemkonto: boolean;
}

export interface IntegrationStatusResponse {
    salaryProvider: SalaryProvider;
    timeRegistrationProvider: TimeRegistrationProvider;
    posProvider: POSProvider;
}

export enum ConnectionStatus {
    CONNECTED = 'Connected',
    NOT_CONNECTED = 'NotConnected',
    CONNECTION_ERROR = 'ConnectionError'
}

export interface SalaryProvider {
    name: string;
    status: ConnectionStatus;
    lastUpdatedAt: string;
}

export interface TimeRegistrationProvider {
    name: string;
    status: string;
    lastUpdatedAt: string;
}

export interface POSProvider {
    name: string;
    status: string;
    lastUpdatedAt: string;
}

export interface SalaryProviderResponse {
    salaryProviders: SalaryProviderItem[];
}

export interface SalaryProviderItem {
    id: number;
    name: string;
    isSalaryProvider: boolean;
    isTimeRegistrationProvider: boolean;
    isPaymentProvider: boolean;
    useCommonData: boolean;
    fileUrl: string;
}

export interface BankTransactionResponse {
    total: number;
    bankTransactions: BankTransaction[];
}

export interface BankTransaction {
    bankTransactionRecordId: string;
    aiiaTransactionId?: string | null;
    aiiaAccountId?: string | null;
    transactionId?: string;
    type?: string;
    comment?: string | null;
    status: string;
    date: Dayjs;
    amount: number;
    aiiaTransaction: any;
    currency: string;
    text?: string | null;
    from?: string | null;
}

export interface BankTransactionRecordDetails {
    bankTransactionRecordId: string;
    aiiaTransactionId: string | null;
    refundAiiaTransactionId: string | null;
    aiiaAccountId: string | null;
    transactionId: string | null;
    employeeId: string | null;
    type: string;
    comment: string | null;
    status: string;
    date: string;
    amount: number;
    currency: string;
    text: string | null;
    from: string | null;
    senderText: string | null;
    message: string | null;
}

export interface CompanyAccountResponse {
    companyAccounts: CompanyAccount[];
}

export interface CompanyAccount {
    companyId: string;
    name: string;
    pendingTransactionsCount: number;
    balance: number;
    currency: string;
}

export interface TransactionDetailsResponse {
    transactionId: string;
    createdAt: Dayjs;
    performedAt: string;
    amount: number;
    currency: string;
    transactionStatus: string;
    userId: string;
    userName: string;
    companyName: string;
    userBankAccountNumber: string;
    userBankCode: string;
    cprNumber: string;
    employmentType: string;
}

export interface ImportResponse {
    jobId: string;
}

export type ImportHistoryResponse = ImportHistory[];

export interface ImportHistory {
    jobId: string;
    jobType: string;
    jobStatus: string;
    companyId: string;
    processedItems: number;
    totalItems: number;
    progress: number;
    newUsersCount: number;
    updatedUsersCount: number;
    deletedUsersCount: number;
    skippedUsersCount: number;
    warnings: string[];
    errors: string[];
    createdAt: Dayjs;
    finishedAt: string;
}

export interface ImportFilterResponse {
    importFilters: ImportFilter[];
}

export interface ImportFilterRequest {
    importFilters: ImportFilter[];
}

export interface ImportFilter {
    filterType: string;
    label: string;
    values: ImportFilterValue[];
}

export interface ImportFilterValue {
    id: string;
    name: string;
    isUsersSyncEnabled: boolean;
}

export interface CurrentCompanyResponse {
    companyId?: string;
    zenegyCompanyId?: string;
    intectCompanyId?: any;
    plandayCompanyId?: string;
    aiiaAccountId?: any;
    aiiaPaymentsAllowedPerAuthorization?: any;
    currency?: string;
    allowancePercentage?: number;
    latestWithdrawalDay?: any;
    hourlyEmployeesPayrollStartDay?: number;
    biweeklyPayrollStartDate?: string; // Date in YYYY-MM-DD format
    transactionEmployerText?: any;
    transactionEmployeeText?: any;
    transactionExecutionType?: TransactionExecutionType;
    salaryAvailableHour?: number;
    timezoneInfoId?: string;
    shiftStatusWithdrawAllowed?: ShiftStatusWithdrawAllowed;
    salaryProvider?: string;
    timeRegistrationProvider?: string;
    usersCount?: number;
    activeUsersCount?: number;
    pricePerUser?: number;
    paymentProvider?: PaymentProvider;
    paymentSource?: PaymentSource;
    approvalType?: ApprovalType;
    accountStatementEmail?: any;
    isDisabled?: boolean;
    showReports?: boolean;
    useCommonSalaryData?: boolean;
    useCommonTimeRegistrationData?: boolean;
    shiftStatusTipsWithdrawAllowed?: ShiftStatusWithdrawAllowed;
    tipsFallbackCalculationAfterDays?: number;
    tipsReportingDay?: number;
    lowBalanceNotificationThreshold?: number | null;
    lowBalanceAudience?: LowBalanceAudience | null;
    lowBalanceEmail?: string | null;
    allowedAvailableShifts?: boolean;
    bankAccountNumber?: string | null;
    transactionCompanyText?: string | null;
    country?: string | null;
    shiftTypes?: ShiftTypes[];
    companyEmail?: string;
    dataPrimarySource?: string;
    endOfTrial?: Date | null;
    enableCustomTransactionMessages?: boolean | undefined;
    companyGroupId?: string;
    employeeTypePrimarySource?: any;
    referencePrimarySource?: any;
    enabledAvailableShiftsInBalance?: boolean;
    enabledUsersAutoEnableByPlandayEmployeeTypes?: boolean;
    notifyPendingWithdrawals?: boolean;
    notifyPendingWithdrawalsHours?: string | null;
    sendWithdrawalsEndOfMonth?: boolean;
    createdAt?: Date;
    intectCompanyToken?: string | null;
    plandayRefreshToken?: string | null;
    useCommonDataProvider?: boolean;
    requiredConsentsAccepted?: boolean;
    theme?: string;
    enableNemkonto?: boolean;
    city?: string;
    postalCode?: string;
    streetAddress?: string;
    withdrawalCountPerDay?: number;
    withdrawalMaxAmountPerTransaction?: number;
    withdrawalMaxAmountPerLast7Days?: number;
    name?: string;
    timeZoneInfoId?: string;
    nameAlias?: string;
    vatNumber?: string;
    contactFirstName?: string;
    contactLastName?: string;
    contactPhoneNo?: string;
    contactEmail?: string;
    logoHeight?: number;
    notifyPendingWithdrawalsEmail?: string | null;
    enabledUsersAutoEnableByEmployeeTypes?: boolean;
    defaultLanguage?: string;
    greetingText?: string | null;
    primaryColor?: string | undefined;
    onPrimaryColor?: string | undefined;
    surfaceColor?: string | undefined;
    onSurfaceColor?: string | undefined;
    backgroundColor?: string | undefined;
    onBackgroundColor?: string | undefined;
    fileUrl?: string | null;
    isCompanyGroup?: boolean;
    creditAmount?: string;
    loginType?: string;
    enableAllowCredit?: boolean;
    enableCompanyGroup?: boolean;
    tenantId?: string;
    customerId?: string;
    transactionId?: string;
    enableTips?: boolean;
    enabledTipsInBalance?: boolean;
    addOnServices?: AddOnService[];
    feePerTipLocation?: number;
    enableTipsAt?: Dayjs | null | string;
    companyServiceFee?: number | null;
    employeeWithdrawalFee?: number | null;
    minimumWithdrawalAmount?: number;
    balanceSummaryTextEn?: string;
    balanceSummaryTextDa?: string;
    isBalanceSummaryOverridden?: boolean;
    regNo?: string | null;
    accountNo?: string | null;
    payrollPeriodType?: 'Monthly' | 'Biweekly';
    posProviderFileUrl?: string | null;
    posProvider?: string | null;
    enableInstaSign?: boolean;
    feePerInstaSignature?: number;
    autoTopupAmount?: number | null;
    lastAutoTopupAmount?: number;
    lastAutoTopupDate?: string;
    autoTopupStatus?: string;
    monthlyAutoTopUpFee?: number | null;
    hasInstaSignDocuments?: boolean;
    autoTopupEnabled?: boolean;
    enableShiftsForHourlyEmployees?: boolean;
    enableShiftsForFixedEmployees?: boolean;
}

type AddOnService = {
    service: string;
    basePrice: number;
    quantity: number;
    locations: number;
    totalPrice: number;
};

type AddPOSLocationRequest = {
    firmaid: string;
    token: string;
    startDate?: string;
};

export type AddTrivecLocationRequest = {
    name: string;
    url: string;
    startDate?: string;
};

export interface GetPosLocationResponse {
    locations: Location[];
}

export interface EmployeeGroupShare {
    employeeGroupId: string;
    employeeGroupName: string;
    earnTips: boolean;
    shareOfTips: number;
}

export interface Location {
    locationId: string;
    locationName: string;
    firmaId: string;
    employeeGroupTemplateId: string;
    employeeGroupTemplateName: string;
    departments: Department[];
    startDate: Dayjs | null;
    employeeGroupsCount: number;
    employeeGroupShares: EmployeeGroupShare[];
}

export interface GetAllPOSDepartmentsResponse {
    departments: Department[];
}

export interface Department {
    departmentId: string;
    departmentName: string;
}

export interface SetPOSLocationDepartmentsRequest {
    locationId: string;
    departmentIds?: string[];
}

export interface POSJournalLinesResponse {
    filters: Filter[];
}

export interface POSJournalPutRequest {
    enableLineTypeIds: string[];
}

export interface Filter {
    lineTypeId: string;
    companyId: string;
    text: string;
    enableForTips: boolean;
}

export interface TrivecGroupFiltersResponse {
    filters: TrivecGroupFilter[];
}

export interface TrivecGroupFilterPutRequest {
    enableGroupIds: string[];
}

export interface TrivecGroupFilter {
    groupId: string;
    companyId: string;
    key: string;
    name: string;
    enableForTips: boolean;
}

export type POSEmployeeGroupResponse = POSEmployeeGroup[];

export interface POSEmployeeGroup {
    employeeGroupId: string;
    name: string;
    earnTips: boolean;
    shareOfTips: any;
}

export type POSProviderResponse = POSProvider[];

export interface POSProvider {
    id: number;
    name: string;
    isSalaryProvider: boolean;
    isTimeRegistrationProvider: boolean;
    isPaymentProvider: boolean;
    useCommonData: boolean;
    isPosProvider: boolean;
    fileUrl: string;
}

export interface TipsResponse {
    payrollPeriodStart: Dayjs;
    payrollPeriodEnd: Dayjs;
    totalAmount: number;
    totalHours: number;
    tips: Tip[];
    total?: number;
    filteredTotal?: number;
}

export interface Tip {
    amount: number;
    currency: string;
    date: Dayjs;
    description: string;
    createdAt: Dayjs;
    startDateTime: Dayjs;
    endDateTime: Dayjs;
    duration: number;
    break: number;
    cost: number;
    status: string;
}

export interface TipsHistoryResponse {
    total: number;
    filteredTotal: number;
    unreportedLocationsInPreviousPayrollsCount: number;
    unreportedSettlementsInPreviousPayrollsCount: number;
    tipsHistory: TipsHistory[];
}

export enum TipsStatus {
    Succeeded = 'Succeeded',
    Awaiting = 'Awaiting'
}

export interface TipsHistory {
    companyId: string;
    companyName: string;
    locationId: string;
    posJournalId: string;
    date: Dayjs;
    showError: boolean;
    locationName: string;
    status: TipsStatus;
    totalTips: number;
    totalEmployeeHours: number;
    lastDistributedAt: Dayjs;
    reportingStatus: string;
    lastReportedAt: Dayjs | null;
    amountSent: number;
    isInCurrentPayrollPeriod: boolean;
    posJournalAmounts?: Array<{ posJournalId: string; totalTips: number }>;
}

export interface TipsHistoryDetailResponse {
    date: string;
    locationName: string;
    totalJournals: number;
    totalHours: number;
    totalTipRecords: number;
    totalTipsAmount: number;
    journals: TipsJournal[];
    singleJournalView: TipsJournal;
}

export interface TipsJournal {
    posJournalId: string;
    reportingStatus: string;
    lastReportedAt: string | null;
    totalHours: number;
    totalTipRecords: number;
    totalTipsAmount: number;
    tipsHistoryDetail: TipsHistoryDetail[];
}

export interface TipsHistoryDetail {
    companyId: string;
    companyName: string;
    posLocationId: string;
    userId: string;
    employeeGroupId: string;
    posJournalId: string;
    name: string;
    workedHours: number;
    employmentType: string;
    employeeGroupName: string;
    isActive: boolean;
    isDisabled: boolean;
    isFirstLogin: boolean;
    shareOfTips: number;
    currentShareOfTips: number;
    earnedTips: number;
    reportedAt?: string;
    shiftId: string;
    shiftStatus: string;
    startDateTime: string;
    endDateTime: string;
    tipsDistributed: boolean;
    estimatedTips: number;
    isShiftTypeExcluded: boolean;
    shiftAvailableForPayout: boolean;
}

export interface TipsReconciliationResponse {
    tipsReconciliationSummary: TipsReconciliationSummary;
    hourlyEmployeesTipsReconciliation: HourlyEmployeesTipsReconciliation[];
    fullTimeEmployeesTipsReconciliation: FullTimeEmployeesTipsReconciliation[];
}

export interface TipsReconciliationSummary {
    monthTotal: number;
    hourlyEmployeesTipsSummary: HourlyEmployeesTipsSummary[];
    fullTimeEmployeesTipsSummary: FullTimeEmployeesTipsSummary[];
}

export interface HourlyEmployeesTipsSummary {
    payrollPeriodStart: string;
    payrollPeriodEnd: string;
    total: number;
}

export interface FullTimeEmployeesTipsSummary {
    payrollPeriodStart: string;
    payrollPeriodEnd: string;
    total: number;
}

export interface HourlyEmployeesTipsReconciliation {
    payrollPeriodStart: string;
    payrollPeriodEnd: string;
    total: number;
    tipsTransactions: TipsTransaction[];
}

export interface TipsTransaction {
    date: Dayjs;
    createdAt: Dayjs;
    reportedAt: Dayjs;
    description: string;
    amount: number;
    sum: number;
}

export interface FullTimeEmployeesTipsReconciliation {
    payrollPeriodStart: string;
    payrollPeriodEnd: string;
    total: number;
    tipsTransactions: TipsTransaction[];
}

export interface TipsReconciliationPDFResponse {
    fileUrl: string;
}

export interface EmploymentGroupsTemplates {
    templateId: string;
    name: string;
    posLocationsCount: number;
    shares: Share[];
}

export interface Share {
    employeeGroupId: string;
    earnTips: boolean;
    shareOfTips: number;
}

export type EmploymentGroupsTemplatesResponse = EmploymentGroupsTemplates[];

export type EmploymentGroupTemplateRequest = {
    name: string;
    shares: Share[];
};

export interface SetEmployeeGroupTemplateRequest {
    locationId: string;
    employeeGroupTemplateId: string;
}

export interface TransactionStatisticsResponse {
    transactionStatistics: TransactionStatistics;
}

export interface TransactionStatistics {
    transactionCount: number;
    averageAmount: number;
    totalAmount: number;
    currency: string;
    periodStartDate: string;
    periodEndDate: string;
}

export interface UpdateJournalAmountRequest {
    posJournalId: string;
    newTotalAmount: string;
}
export interface DocumentResponse {
    documents: Document[];
    total: number;
}

export interface Document {
    documentId: string;
    version: number;
    isEditable: boolean;
    requiresReSign: boolean;
    createdAt: string;
    status: string;
    files: DocumentFile[];
}

export interface UploadDocResponse {
    pageCount: number;
    pageWidth: number;
    pageHeight: number;
    pdfUrl: string;
}

export interface DocumentFile {
    name: string;
    url: string;
    signatureX: number;
    signatureY: number;
    signatureWidth: number;
    signatureHeight: number;
    signaturePageNumber: number;
    language: string;
}

export interface CreateDocumentRequest {
    requiresNewSignatureFromAll: boolean;
    status: string;
    documentFiles: DocumentFile[];
}

export interface UpdateDocumentRequest {
    requiresNewSignatureFromAll: boolean;
    status: string;
    documentFiles: DocumentFile[];
}

export interface SignaturesResponse {
    signatures: Signature[];
    total: number;
    filteredTotal: number;
}

export interface Signature {
    signatureId: string;
    employeeName: string;
    employeeEmail: string;
    documentUrl: string;
    documentName: string;
    documentVersion: number;
    signedAt: string;
    signatureUrl: string;
    signedFileUrl: string;
}

class PaymentsAPIServiceV2 extends BaseAPI {
    client!: AxiosInstance;

    static instance: PaymentsAPIServiceV2;

    private constructor() {
        super();
        (async () => {
            const PAYMENT_API_BASE_URL = (
                await MSALHolder.getInstance()
            ).getSpaConfiguration()?.backendPaymentsServiceUrl;
            // deepcode ignore PrototypePollution: Data from the server is trusted
            this.client = this.getClient(PAYMENT_API_BASE_URL!);
        })();

        PaymentsAPIServiceV2.instance = this;
    }

    getUpcomingShifts = async (userId: string) => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/shifts/upcoming?employeeId=${userId}`, {
            headers
        });
    };

    getAvailableShifts = async (userId: string) => {
        const headers = await this.getAuthHeaders();
        return this.client.get(
            `/api/v2/shifts/available?employeeId=${userId}`,
            {
                headers
            }
        );
    };

    enableUsers = async (
        request: ChangeUsersStatusRequest,
        companyId?: string
    ) => {
        const headers = await this.getAuthHeaders(companyId);

        return this.client.post(`/api/v2/users/enable`, request, { headers });
    };

    getUser = async (userId: string): Promise<{ data: UserResponse }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/users/get/${userId}`, { headers });
    };

    getTransactionsHistory = async (
        limit = 10,
        offset = 0,
        startDate?: any,
        endDate?: any
    ) => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/transactions/history`, {
            headers,
            params: {
                offset,
                limit,
                startDate,
                endDate
            }
        });
    };

    getUserTransactionHistory = async (
        userId: string,
        limit = 10,
        offset = 0
    ) => {
        const headers = await this.getAuthHeaders();

        return this.client.get(
            `/api/v2/employee/${userId}/transactions/history/`,
            {
                headers,
                params: {
                    offset,
                    limit
                }
            }
        );
    };

    getUsersDetails = async <
        T extends GetZenegyUsersDetailedReqest | GetIntectUsersDetailedReqest
    >(
        request?: Partial<T>
    ): Promise<{ data: UserDetailedResponse<ZenegyUserDetailed> }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(
            `/api/v2/companies/current/users?${this.buildGetQuery(request)}`,
            { headers }
        );
    };

    getCurrentImportJob = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/jobs/currentImport`, { headers });
    };

    getProvider = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/provider`, { headers });
    };

    aiiaRefreshPayment = async (transactionId: string) => {
        const headers = await this.getAuthHeaders();
        return this.client.get(
            '/api/v2/aiia/payment?transactionId=' + transactionId,
            { headers }
        );
    };

    getDownloadTransactions = async (startDate: any, endDate: any) => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/transactions/history/download`, {
            headers,
            params: {
                startDate,
                endDate
            }
        });
    };

    getExportTransactionsPdf = async (startDate: any, endDate: any) => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/transactions/history/pdf/generate`, {
            headers,
            params: {
                startDate,
                endDate
            }
        });
    };

    getExportReconciliationPdf = async (month: number, year: number) => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/reconciliationReport/pdf/generate`, {
            headers,
            params: {
                month,
                year
            }
        });
    };

    getCurrentCompanyBalance = async (): Promise<{
        data: CompanyBalanceResponse;
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/company/balance`, { headers });
    };

    //TODO: remove this later for the single function
    getCurrentCompany = async (): Promise<{ data: CurrentCompanyResponse }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get('/api/companyDetails', { headers });
    };

    getReconciliation = async (month: number, year: number) => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/reconciliationReport`, {
            headers,
            params: {
                month,
                year
            }
        });
    };

    createCompanyAccountTransaction = async (
        request: CreateCompanyAccountTransactionRequest
    ) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(
            `/api/v2/companyAccountTransaction/create`,
            request,
            { headers }
        );
    };

    updateUserBankAccountDetails = async (
        request: UpdateUserBankAccountDetailsRequest
    ) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(
            `/api/v2/users/updateBankDetails/${request.userId}`,

            request,
            { headers }
        );
    };

    updateCurrentCompany = async (request: UpdateCompanyPaymentsRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.put('/api/v2/company/update', request, { headers });
    };

    refreshImportParameters = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/import/refreshParameters', null, {
            headers
        });
    };

    plandaySetup = async (request: PlandaySetupRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/planday/setup', request, { headers });
    };

    tamigoSetup = async (request: TamigoSetupRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/tamigo/setup', request, { headers });
    };

    titanPlanSetup = async (request: TitanPlanRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/titanPlan/setup', request, {
            headers
        });
    };

    sameSystemSetup = async (request: SameSystemRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/sameSystem/setup', request, {
            headers
        });
    };

    dataLonSetup = async (request: DataLonSetupRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/dataLon/setup', request, {
            headers
        });
    };

    trivecSetup = async (request: TrivecSetupRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/trivec/setup', request, {
            headers
        });
    };

    getPendingTransactions = async (): Promise<{
        data: TransactionsDetailedResponse;
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get('/api/v2/transactions/pending', { headers });
    };

    zenegyExchangeToken = async (request: ZenegyExchangeCodeRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/zenegy/exchange', request, {
            headers
        });
    };

    cancelJob = async (jobId: string) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(
            `/api/v2/jobs/cancel/${jobId}`,
            {},
            { headers }
        );
    };

    updateSalaryProvider = async (request: UpdateSalaryProviderRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/salaryProvider/update', request, {
            headers
        });
    };

    updateTimeRegistrationProvider = async (
        request: UpdateTimeRegistrationProviderRequest
    ) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(
            '/api/v2/timeRegistrationProvider/update',
            request,
            { headers }
        );
    };

    downloadTransactions = async (startDate: any, endDate: any) => {
        const headers = await this.getAuthHeaders();
        return this.client.get(
            `/api/v2/transactions/history/download?startDate=${startDate}&endDate=${endDate}`,
            { headers }
        );
    };

    getAiiaRegenerateAuthorizeUrl = async (
        request: GetAiiaRetryAuthorizeUrlRequest
    ) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(
            '/api/v2/aiia/regenerateAuthorizeUrl',
            request,
            {
                headers
            }
        );
    };

    getAiiaRetryAuthorizeUrl = async (
        request: GetAiiaRetryAuthorizeUrlRequest
    ) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/aiia/retryAuthorize', request, {
            headers
        });
    };

    getZenegyDepartments = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/departments`, { headers });
    };

    getIntectDepartments = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/intect/departments`, { headers });
    };

    getIntectEmploymentTemplates = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/intect/employmentTemplates`, {
            headers
        });
    };

    getUserBalance = async (userId: string) => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/balance?employeeId=${userId}`, {
            headers
        });
    };

    getPayrollStatus = async (
        employeeId: string
    ): Promise<{ data: { payrollProcessed: boolean } }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(
            `/api/v2/balance/payroll-status?employeeId=${employeeId}`,
            {
                headers
            }
        );
    };

    getUserTips = async (userId: string): Promise<{ data: TipsResponse }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/earnedTips?employeeId=${userId}`, {
            headers
        });
    };

    getUserPastTips = async (
        userId: string,
        startDate?: string,
        endDate?: string,
        offset?: number,
        limit?: number
    ): Promise<{ data: TipsResponse }> => {
        const headers = await this.getAuthHeaders();
        const params: any = { employeeId: userId };

        if (startDate) params.startDate = startDate;
        if (endDate) params.endDate = endDate;
        if (offset !== undefined) params.offset = offset;
        if (limit !== undefined) params.limit = limit;

        return this.client.get(`/api/v2/pastTips`, {
            headers,
            params
        });
    };

    getUserShifts = async (userId: string) => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/shifts?employeeId=${userId}`, {
            headers
        });
    };

    getCompanyAccounts = async (): Promise<{
        data: CompanyAccountResponse;
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get('/api/companyAccounts', { headers });
    };

    getAllIntegrationStatus = async (): Promise<{
        data: IntegrationStatusResponse;
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/integrationStatus`, { headers });
    };

    sendDeleteCompanyVerificationEmail = async (
        request: SendDeleteCompanyVerificationEmailRequest
    ) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(
            '/api/company/sendDeleteCompanyVerificationEmail',
            request,
            { headers }
        );
    };

    deleteCompany = async (request: DeleteCompanyRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/company/delete', request, { headers });
    };

    getAiiaConnectUrl = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/aiia/connect', null, { headers });
    };

    aiiaExchangeToken = async (request: AiiaExchangeCodeRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/aiia/exchange', request, { headers });
    };

    aiiaGetAuthorizationPayments = async (authorizationId: string) => {
        const headers = await this.getAuthHeaders();
        return this.client.get(
            '/api/v2/aiia/authorization?authorizationId=' + authorizationId,
            { headers }
        );
    };

    aiiaRegenerateAuthorizeUrl = async (
        request: GetAiiaRetryAuthorizeUrlRequest
    ) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(
            '/api/v2/aiia/regenerateAuthorizeUrl',
            request,
            {
                headers
            }
        );
    };

    getCompanyDanskeBankSettings = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/company/danskeBankSettings`, {
            headers
        });
    };

    updateCompanyDanskeBankSettings = async (
        request: UpdateCompanyDanskeBankSettingsRequest
    ) => {
        const headers = await this.getAuthHeaders();
        return this.client.put(
            `/api/v2/company/updateDanskeBankSettings`,
            request,
            { headers }
        );
    };

    getZenegyConnectUrl = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/zenegy/connect', null, { headers });
    };

    intectAuthorize = async (request: IntectAuthorizeRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/intect/authorize', request, {
            headers
        });
    };

    approveTransactions = async (request: ApproveTransactionsRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/transactions/approve', request, {
            headers
        });
    };

    getAiiaAuthorizeUrl = async (request: GetAiiaAuthorizeUrlRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/aiia/authorize', request, { headers });
    };

    rejectTransactions = async (request: RejectTransactionsRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/transactions/reject', request, {
            headers
        });
    };

    importUsers = async (): Promise<{ data: ImportResponse }> => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/users/import', null, { headers });
    };

    getJobStatus = async (jobId: string) => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/jobs?jobId=${jobId}`, { headers });
    };

    getLastJobs = async (): Promise<{ data: ImportHistoryResponse }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/jobs/history?offset=0&limit=5`, {
            headers
        });
    };

    getTimezones = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/timezones`, { headers });
    };

    updateZenegyDepartments = async (request: UpdateDepartmentsRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/departments/update', request, {
            headers
        });
    };

    getZenegyEmployeeTypes = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/employeeTypes`, { headers });
    };

    updateZenegyEmployeeTypes = async (request: UpdateEmployeeTypesRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/employeeTypes/update', request, {
            headers
        });
    };

    getZenegySalaryModes = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/salaryModes`, { headers });
    };

    updateZenegySalaryModes = async (request: UpdateSalaryModesRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/salaryModes/update', request, {
            headers
        });
    };

    getZenegySalaryTypes = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/salaryTypes`, { headers });
    };

    updateZenegySalaryTypes = async (request: UpdateSalaryTypesRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/salaryTypes/update', request, {
            headers
        });
    };

    updateIntectDepartments = async (
        request: UpdateIntectDepartmentsRequest
    ) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/intect/departments/update', request, {
            headers
        });
    };

    updateIntectEmploymentTemplates = async (
        request: UpdateIntectEmploymentTemplateRequest
    ) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(
            '/api/v2/intect/employmentTemplates/update',
            request,
            { headers }
        );
    };

    getUserCompanies = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.get('/api/users/current/companies', {
            headers
        });
    };

    getAdminCompanies = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.get('/api/v2/companies', {
            headers
        });
    };

    updateCompanyDetails = async (request: CompanyDetailsResponse) => {
        const headers = await this.getAuthHeaders();
        return this.client.put('/api/updateCompanyDetails', request, {
            headers
        });
    };

    getCompanyUsers = async (limit = 10, offset = 0) => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/company/settings/users`, {
            headers,
            params: {
                offset,
                limit
            }
        });
    };

    getCompanyByUserId = async (userId: string) => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/user/companies/${userId}`, { headers });
    };

    failTransactionInSalarySystem = async (
        request: FailTransactionsRequest
    ) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(`/api/transactions/fail`, request, { headers });
    };

    succeedTransactionInSalarySystem = async (
        request: SucceedTransactionsRequest
    ) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(`/api/transactions/succeed`, request, {
            headers
        });
    };

    getTimeRegistrationProviders = async (): Promise<{
        data: TimeRegistrationProviders;
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get('/api/timeregistrationprovider', {
            headers
        });
    };

    getSalaryProviders = async (): Promise<{
        data: SalaryProviderResponse;
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get('/api/salaryprovider', {
            headers
        });
    };

    getEmployeeTypes = async (): Promise<{
        data: EmployeeTypeV2Response;
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get('/api/v2/companies/current/employeeTypes', {
            headers
        });
    };

    getEmployeeDepartments = async (): Promise<{
        data: DepartmentV2Response;
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get('/api/v2/companies/current/departments', {
            headers
        });
    };

    getEmployeeAutoApprovalTypes = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/employeeTypes`, {
            headers
        });
    };

    postEmployeeTypesAutoEnable = async (data: any) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(`/api/employeeTypes/autoenable`, data, {
            headers
        });
    };

    postEmployeeTypesUpdate = async (data: any) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(`/api/employmentTypes/update`, data, {
            headers
        });
    };

    sendDisableCompanyVerificationEmail = async (
        data: CompanyDisableVerificationEmailRequest
    ) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(
            `/api/company/sendDisableCompanyVerificationEmail`,
            data,
            {
                headers
            }
        );
    };

    updateCompanyStatus = async (data: CompanyStatusRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(`/api/company/status`, data, {
            headers
        });
    };

    searchByUsername = async (request: GetUsersDetailedRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/users?${this.buildGetQuery(request)}`, {
            headers
        });
    };

    uploadTaxCard = async (file: File) => {
        const headers = await this.getAuthHeaders();
        const formData = new FormData();
        formData.append('aa', file);

        return this.client.post('/api/v2/tax-cards/upload', formData, {
            headers
        });
    };

    updatePlandayChildCompany = async (data: {
        portalId: number;
        clientId: string;
        refreshToken: string;
    }) => {
        const headers = await this.getAuthHeaders();
        return this.client.put(`/api/v2/planday/childcompany`, data, {
            headers
        });
    };

    getAllBankTransactionRecords = async (
        statuses?: string[],
        limit?: number,
        offset?: number
    ): Promise<{
        data: BankTransactionResponse;
    }> => {
        const headers = await this.getAuthHeaders();

        if (statuses && statuses.length > 0) {
            let allStatuses = statuses
                .map((status) => `statuses=${status}`)
                .join('&');
            return this.client.get(`/api/v2/bankTransactionRecords`, {
                headers,
                params: {
                    limit,
                    offset
                },
                paramsSerializer: (params) => {
                    return (
                        allStatuses +
                        '&' +
                        new URLSearchParams(params).toString()
                    );
                }
            });
        } else {
            return this.client.get(`/api/v2/bankTransactionRecords`, {
                headers,
                params: {
                    limit,
                    offset
                }
            });
        }
    };

    getSyncBankTransactionRecords = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.post(
            '/api/v2/bankTransactionRecords/sync',
            {},
            {
                headers
            }
        );
    };

    ignoreBankTransactionRecord = async ({
        bankTransactionRecordId,
        comment
    }: {
        bankTransactionRecordId: string;
        comment: string;
    }) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(
            `/api/v2/bankTransactionRecords/ignore`,
            { bankTransactionRecordId, comment },
            {
                headers
            }
        );
    };

    getTransactionBankDetails = async (
        transactionId: string
    ): Promise<{ data: TransactionDetailsResponse }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(
            `/api/v2/transactionBankDetails/${transactionId}`,
            {
                headers
            }
        );
    };

    cancelTransaction = async ({
        bankTransactionRecordId,
        transactionId
    }: {
        bankTransactionRecordId: string;
        transactionId: string;
    }) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(
            `/api/v2/bankTransactionRecords/cancelTransaction`,
            { bankTransactionRecordId, transactionId },
            {
                headers
            }
        );
    };

    topUpCompanyAccountWithTransaction = async ({
        bankTransactionRecordId,
        companyId,
        comment
    }: {
        bankTransactionRecordId: string;
        companyId: string;
        comment: string;
    }) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(
            `/api/v2/bankTransactionRecords/topup`,
            {
                bankTransactionRecordId,
                companyId,
                comment
            },
            {
                headers
            }
        );
    };

    getBankTransactionRecordDetails = async (
        bankTransactionRecordId: string
    ): Promise<{ data: BankTransactionRecordDetails }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(
            `/api/v2/bankTransactionRecords/${bankTransactionRecordId}`,
            {
                headers
            }
        );
    };

    getImportFilters = async (): Promise<{ data: ImportFilterResponse }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/importFilters`, { headers });
    };

    getImportFiltersForSource = async (
        sourceType: string
    ): Promise<{ data: ImportFilterResponse }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/importFilters/source/${sourceType}`, {
            headers
        });
    };

    setImportFilter = async (data: ImportFilterRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(`/api/v2/importFilters`, data, { headers });
    };

    setImportFilterForSource = async (
        sourceType: string,
        data: ImportFilterRequest
    ) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(
            `/api/v2/importFilters/source/${sourceType}`,
            data,
            { headers }
        );
    };

    proloenSetup = async (data: ProloenSetupRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(`/api/proloen/setup`, data, { headers });
    };

    eposSetup = async (data: EPOSSetupRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(`/api/v2/epos/setup`, data, { headers });
    };

    staffSetup = async (data: StaffSetupRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(`/api/v2/staff/setup`, data, { headers });
    };

    lessorSetup = async (data: LessorSetupRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(`/api/v2/lessor/setup`, data, { headers });
    };

    quinyxSetup = async (data: QuinyxSetupRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(`/api/v2/quinyx/setup`, data, { headers });
    };

    dagrofaLonSetup = async (data: DagrofaLonSetupRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(`/api/v2/dagrofaLon/setup`, data, {
            headers
        });
    };

    getDepartments = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`api/departments`, { headers });
    };

    getEmployeeSickness = async (
        departments?: string,
        startDate?: string,
        endDate?: string
    ) => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`api/employeeSickness`, {
            headers,
            params: { departments: departments, startDate, endDate }
        });
    };

    getDanLonConnectURL = async (): Promise<{
        data: { connectUrl: string };
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.post(
            `api/v2/danlon/connect`,
            {},
            {
                headers,
                params: {
                    // redirect_uri:
                    //     'http://admin-test.instapaid.io/settings/general'
                }
            }
        );
    };

    dalonExchange = async (
        code: string
    ): Promise<{
        data: { selectCompanyUrl: string };
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.post(
            `api/v2/danlon/exchange`,
            {
                code
            },
            { headers }
        );
    };

    dalonCode2Token = async (
        code: string
    ): Promise<{
        data: { token: string };
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.post(
            `api/v2/danlon/code2token`,
            { code },
            { headers }
        );
    };

    getEmployeeDetails = async ({
        departments,
        startDate,
        endDate
    }: EmployeeDetailRequest): Promise<{
        data: EmployeeDetailResponse;
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`api/employeeDetails`, {
            headers,
            params: { departments, startDate, endDate }
        });
    };

    getPOSLocationsAndDepartments = async (): Promise<{
        data: GetPosLocationResponse;
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`api/v2/onlinePos/locations`, { headers });
    };

    addPOSLocation = async (data: AddPOSLocationRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(`api/v2/onlinePos/add`, data, { headers });
    };

    addTrivecLocation = async (data: AddTrivecLocationRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(`api/v2/trivec/add`, data, { headers });
    };

    getAllPOSDepartments = async (): Promise<{
        data: GetAllPOSDepartmentsResponse;
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`api/v2/departments/common`, { headers });
    };

    setPOSLocationDepartments = async (
        data: SetPOSLocationDepartmentsRequest
    ) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(`api/v2/pos/location/departments`, data, {
            headers
        });
    };

    deletePOSLocation = async (locationId: string) => {
        const headers = await this.getAuthHeaders();
        return this.client.delete(`api/v2/onlinePos/delete`, {
            data: {
                locationId
            },
            headers
        });
    };

    getPOSJournalLines = async (): Promise<{
        data: POSJournalLinesResponse;
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`api/v2/onlinePos/journalLineFilters`, {
            headers
        });
    };

    putPOSJournalLines = async (data: POSJournalPutRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.put(`api/v2/onlinePos/journalLineFilters`, data, {
            headers
        });
    };

    syncPOSJournalLinesFilters = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.put(
            `api/v2/onlinePos/journalLineFilters/sync`,
            {},
            {
                headers
            }
        );
    };

    syncTrivecJournals = async (date: string) => {
        const headers = await this.getAuthHeaders();
        return this.client.put(
            `api/v2/trivec/journal/sync`,
            { date },
            {
                headers
            }
        );
    };

    getTrivecGroupFilters = async (): Promise<{
        data: TrivecGroupFiltersResponse;
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`api/v2/trivec/groupFilters`, {
            headers
        });
    };

    putTrivecGroupFilters = async (data: TrivecGroupFilterPutRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.put(`api/v2/trivec/groupFilters`, data, {
            headers
        });
    };

    getTipsEmployeeGroup = async (): Promise<{
        data: POSEmployeeGroupResponse;
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`api/v2/employeeGroup`, { headers });
    };

    getPOSProviders = async (): Promise<{ data: POSProviderResponse }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`api/posproviders`, { headers });
    };

    putTipsEmployeeGroup = async (data: POSEmployeeGroup[]) => {
        const headers = await this.getAuthHeaders();
        return this.client.put(
            `api/v2/employeeGroup`,
            { employeeGroups: data },
            { headers }
        );
    };

    getTipsHistory = async ({
        offset,
        limit,
        locationIds,
        statuses,
        reportingStatuses,
        signal
    }: {
        offset?: number;
        limit?: number;
        locationIds?: string[];
        statuses?: string[];
        reportingStatuses?: string[];
        signal?: AbortSignal;
    }): Promise<{ data: TipsHistoryResponse }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/tips/history`, {
            headers,
            params: {
                offset,
                limit,
                locationIds: locationIds?.length
                    ? locationIds.join(',')
                    : undefined,
                statuses: statuses?.length ? statuses.join(',') : undefined,
                reportingStatuses: reportingStatuses?.length
                    ? reportingStatuses.join(',')
                    : undefined
            },
            signal
        });
    };

    getTipsHistoryExcelDownload = async ({
        locationIds,
        statuses,
        reportingStatuses
    }: {
        locationIds?: string[];
        statuses?: string[];
        reportingStatuses?: string[];
    }): Promise<{ data: TipsHistoryResponse }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/tips/history/download`, {
            headers,
            params: {
                locationIds: locationIds?.length
                    ? locationIds.join(',')
                    : undefined,
                statuses: statuses?.length ? statuses.join(',') : undefined,
                reportingStatuses: reportingStatuses?.length
                    ? reportingStatuses.join(',')
                    : undefined
            }
        });
    };

    getTipsReconciliationReport = async (
        month: string,
        year: string
    ): Promise<{ data: TipsReconciliationResponse }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/tips/reconciliationReport`, {
            headers,
            params: {
                month,
                year
            }
        });
    };

    getEstimatedTipsReconciliationReport = async (
        month: string,
        year: string
    ): Promise<{ data: TipsReconciliationResponse }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/tips/estimatedReconciliationReport`, {
            headers,
            params: {
                month,
                year
            }
        });
    };

    getTipsHistoryDetails = async ({
        posLocationId,
        date
    }: {
        posLocationId: string;
        date: string;
    }): Promise<{ data: TipsHistoryDetailResponse }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/tips/history/detail/date`, {
            headers,
            params: {
                posLocationId,
                date
            }
        });
    };

    getTipsReconciliationReportPDF = async (
        month: string,
        year: string
    ): Promise<{ data: TipsReconciliationPDFResponse }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(
            `/api/v2/tips/reconciliationReport/pdf/generate`,
            {
                headers,
                params: {
                    month,
                    year
                }
            }
        );
    };

    getEstimatedTipsReconciliationReportPDF = async (
        month: string,
        year: string
    ): Promise<{ data: TipsReconciliationPDFResponse }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(
            `/api/v2/tips/estimatedReconciliationReport/pdf/generate`,
            {
                headers,
                params: {
                    month,
                    year
                }
            }
        );
    };

    getActivePayrollPeriods = async (): Promise<{
        data: { periods: Array<{ start: string; end: string; label: string }> };
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/tips/active-payroll-periods`, {
            headers
        });
    };

    balanceTextSummaryReset = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.post(
            `/api/balanceSummary/reset`,
            {},
            {
                headers
            }
        );
    };

    getEmploymentGroupTemplates = async (): Promise<{
        data: EmploymentGroupsTemplatesResponse;
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/employeeGroupTemplates`, { headers });
    };

    getTransactionStatistics = async (): Promise<{
        data: TransactionStatisticsResponse;
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/v2/transactions/statistics`, {
            headers
        });
    };

    createEmploymentGroupTemplate = async (
        data: EmploymentGroupTemplateRequest
    ) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(`/api/v2/employeeGroupTemplate`, data, {
            headers
        });
    };

    deleteEmploymentGroupTemplate = async (id: string) => {
        const headers = await this.getAuthHeaders();
        return this.client.delete(`/api/v2/employeeGroupTemplate/${id}`, {
            headers
        });
    };

    setEmployeeGroupTemplate = async (
        data: SetEmployeeGroupTemplateRequest
    ) => {
        const headers = await this.getAuthHeaders();
        return this.client.put(
            `/api/v2/pos/location/employeeGroupTemplate`,
            data,
            {
                headers
            }
        );
    };

    getEmployeeDocuments = async (): Promise<{ data: DocumentResponse }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get(`/api/documents`, {
            headers
        });
    };

    deleteDocument = async (documentId: string) => {
        const headers = await this.getAuthHeaders();
        return this.client.delete(`/api/document/delete/${documentId}`, {
            headers
        });
    };

    updateEmployeeGroupTemplate = async ({
        id,
        data
    }: {
        id: string;
        data: EmploymentGroupTemplateRequest;
    }) => {
        const headers = await this.getAuthHeaders();
        return this.client.put(`/api/v2/employeeGroupTemplate/${id}`, data, {
            headers
        });
    };

    updateJournalAmount = async (data: UpdateJournalAmountRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(`/api/update/journal/amount`, data, {
            headers
        });
    };

    documentUpload = async (
        file: File
    ): Promise<{ data: UploadDocResponse }> => {
        const headers = await this.getAuthHeaders();
        const formData = new FormData();
        formData.append('file', file);

        return this.client.post('/api/document/upload', formData, {
            headers
        });
    };

    generateDocumentImage = async ({
        url,
        pageNumber
    }: {
        url: string;
        pageNumber: number;
    }) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(
            '/api/document/generateImage',
            {
                url,
                pageNumber
            },
            { headers, responseType: 'blob' }
        );
    };

    createDocument = async (data: CreateDocumentRequest) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/document/create', data, { headers });
    };

    updateDocument = async (
        documentId: string,
        data: UpdateDocumentRequest
    ) => {
        const headers = await this.getAuthHeaders();
        return this.client.put(`/api/document/update/${documentId}`, data, {
            headers
        });
    };

    getSignatures = async (
        limit: number = 16,
        offset: number = 0,
        searchQuery?: string,
        sortField?: string,
        sortDirection?: string
    ): Promise<{ data: SignaturesResponse }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get('/api/signatures', {
            headers,
            params: {
                limit,
                offset,
                searchQuery,
                sortField,
                sortDirection
            }
        });
    };

    getMasterCardConnectUrl = async (): Promise<{
        data: { connectUrl: string };
    }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get('/api/v2/mastercard/connect', { headers });
    };

    retryTipsReport = async () => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/tips/report', {}, { headers });
    };

    getHoursWorkedReport = async (
        startDate: string,
        endDate: string,
        groupBy: 'department' | 'group',
        hoursFilter: 'All' | 'LessThan96' | 'MoreThan200'
    ): Promise<{ data: any }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get('/api/hoursWorked', {
            headers,
            params: {
                startDate,
                endDate,
                groupBy,
                filter: hoursFilter
            }
        });
    };

    getOvertimeReport = async (
        startDate: string,
        endDate: string,
        groupBy: 'department' | 'group'
    ): Promise<{ data: any }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get('/api/overtime', {
            headers,
            params: {
                startDate,
                endDate,
                groupBy
            }
        });
    };

    getEmployeeChurnReport = async (
        startDate: string,
        endDate: string,
        groupBy: 'department' | 'group'
    ): Promise<{ data: any }> => {
        const headers = await this.getAuthHeaders();
        return this.client.get('/api/employeeChurn', {
            headers,
            params: {
                startDate,
                endDate,
                groupBy
            }
        });
    };

    sendToggleTipsInBalanceVerificationEmail = async (companyId: string) => {
        const headers = await this.getAuthHeaders();
        return this.client.post(
            '/api/v2/tips/sendToggleTipsInBalanceVerificationEmail',
            { companyId },
            { headers }
        );
    };

    toggleTipsInBalance = async (request: {
        companyId: string;
        enabledTipsInBalance: boolean;
        verificationCode: string;
    }) => {
        const headers = await this.getAuthHeaders();
        return this.client.post('/api/v2/tips/toggleTipsInBalance', request, {
            headers
        });
    };

    static getInstance = () => {
        if (this.instance) {
            return this.instance;
        } else {
            this.instance = new PaymentsAPIServiceV2();
            return this.instance;
        }
    };
}

export default PaymentsAPIServiceV2;
